module.exports = __webpack_public_path__ + "media/site_templates/www.cabinetmaker.company/images/our_services_1-1953159d5928e5d325037bd370886af5.jpg";